import { OpstelApiClient } from "@opstel/query/v2/opstelClient";
import React, { PropsWithChildren, useMemo } from "react";
import { OpstelClientContext } from "./OpstelClientContext";

interface OpstelClientProviderProps extends PropsWithChildren {
  readonly opstelClient: OpstelApiClient;
}

export function OpstelClientProvider({
  opstelClient,
  children,
}: OpstelClientProviderProps): React.JSX.Element {
  const opstelClientContextProps = useMemo(() => ({ opstelClient }), [opstelClient]);

  return (
    <OpstelClientContext.Provider value={opstelClientContextProps}>
      {children}
    </OpstelClientContext.Provider>
  );
}
